import {
  ClockClockwiseIcon,
  CookieIcon,
  CurrencyCircleDollarIcon,
  FileTextIcon,
  HouseIcon,
  ReceiptIcon,
  SignOutIcon,
  SwapIcon,
  WalletIcon,
  /* TODO - Treasury */
  //VaultIcon,
} from '@phosphor-icons/react';
import { APP_VERSION } from './app'
import React from 'react';
import { FEATURE_FLAGS } from './feature-flags';

export interface IMenuLink {
  icon?: React.ReactNode
  name: string
  link: string
  class?: string
  featureFlag?: string // Optional feature flag to control visibility
}

export interface IMenuItem {
  label: string | React.ReactNode
  links?: IMenuLink[]
  class?: string
}

export const menu_define = (t: (key: string) => string): IMenuItem[] => [
  {
    label: null,
    links: [
      {
        icon: <HouseIcon size={24} color="#000" weight="fill" />,
        name: `${t('sidebar.my_portfolio')}`,
        link: '/',
      },
    ],
    class: 'sidebar-section-no-padding',
  },
  {
    label: `${t('sidebar.wealth_products')}`,
    links: [
      {
        icon: (
          <CurrencyCircleDollarIcon size={24} weight={'thin'} />
        ),
        name:`${t('sidebar.main_account')}`,
        link: '/main-account/',
        featureFlag: 'ENABLE_ASSET_MANAGEMENT',
      },
      ...(FEATURE_FLAGS.EXCHANGE_ENABLED ? [{
        icon: (
          <SwapIcon size={24} weight={'thin'} color={'rgb(116, 116, 127)'} />
        ),
        name: `${t('sidebar.exchange')}`,
        link: '/exchange/',
        featureFlag: 'ENABLE_EXCHANGE_FEATURE',
      }] : []),
      {
        icon: (
          <ClockClockwiseIcon
            size={24}
            weight={'thin'}
            color={'rgb(116, 116, 127)'}
          />
        ),
        name: `${t('sidebar.dca_strategy')}`,
        link: '/dca-strategy/',
        featureFlag: 'ENABLE_DCA_FEATURE',
      },
      {
        icon: (
          <WalletIcon
            size={24}
            weight={'thin'}
            color={'rgb(116, 116, 127)'}
          />
        ),
        name: `${t('sidebar.management_mandate')}`,
        link: '/management-mandate/',
        featureFlag: 'ENABLE_MANDATE_FEATURE',
      },
      /* TODO - Treasury */
      // {
      //   icon: (
      //     <VaultIcon
      //       size={24}
      //       weight={'thin'}
      //       color={'rgb(116, 116, 127)'}
      //     />
      //   ),
      //   name: `${t('sidebar.treasury')}`,
      //   link: '/treasury/',
      //   featureFlag: 'ENABLE_TREASURY_FEATURE',
      // },
    ],
  },
  {
    label: `${t('sidebar.legal')}`,
    links: [
      {
        icon: <FileTextIcon size={24} weight={'thin'} color={'rgb(116, 116, 127)'} />,
        name: `${t('sidebar.terms_of_use')}`,
        link: '/legal/terms-of-use/',
      },
      {
        icon: <FileTextIcon size={24} weight={'thin'} color={'rgb(116, 116, 127)'} />,
        name: `${t('sidebar.legal_notices')}`,
        link: '/legal/legal-notices/',
      },
      {
        icon: <CookieIcon size={24} weight={'thin'} color={'rgb(116, 116, 127)'} />,
        name: `${t('sidebar.cookie_management_policy')}`,
        link: '/legal/cookie-management-policy/',
      },
      {
        icon: <ReceiptIcon size={24} weight={'thin'} color={'rgb(116, 116, 127)'} />,
        name: `${t('sidebar.fees')}`,
        link: '/legal/fees/',
        featureFlag: 'ENABLE_FEE_MANAGEMENT',
      },
    ],
  },
  {
    label: null,
    class: 'sidebar-section-no-padding',
    links: [
      {
        icon: <SignOutIcon size={24} weight="thin" color="#FF0000" />,
        name: `${t('sidebar.logout')}`,
        link: '/auth/login',
        class: 'logout',
      },
    ],
  },
  {
    label: <span style={{ textAlign: 'center', width: "100%", display: 'inline-block', marginLeft: -12 }}>{APP_VERSION}</span>,
    class: 'sidebar-section-no-padding'
  },
]

// Helper function to filter menu items based on feature flags
export const filterMenuByFeatures = (
  menu: IMenuItem[],
  features: Record<string, boolean | string>
): IMenuItem[] => {
  return menu.map(section => {
    if (!section.links) return section;

    const filteredLinks = section.links.filter(link => {
      // If no feature flag, always show
      if (!link.featureFlag) return true;

      const featureValue = features[link.featureFlag];
      // If feature flag is not set (undefined), default to enabled
      return featureValue === undefined || featureValue === true;
    });

    // If all links are filtered out, don't show the section
    if (filteredLinks.length === 0 && section.links.length > 0) {
      return null;
    }

    return { ...section, links: filteredLinks };
  }).filter((section): section is IMenuItem => section !== null);
}
